import ContractorTimesheetView from "./components/ContractorTimesheetView";
import React from "react";
const ContractorTimesheetPage = () => {
  return (
    <>
      <ContractorTimesheetView />
    </>
  );
};

export default ContractorTimesheetPage;